import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--password" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl c-ttl" }, "パスワード 変更", -1)
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = { class: "p-mypage__field-container" }
const _hoisted_5 = { class: "p-errors" }
const _hoisted_6 = { class: "c-error" }
const _hoisted_7 = { class: "p-fields" }
const _hoisted_8 = { class: "c-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "oldPassword"
}, [
  /*#__PURE__*/_createTextVNode("現在のパスワード"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_10 = { class: "c-field__body" }
const _hoisted_11 = { class: "c-field__input" }
const _hoisted_12 = { class: "c-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newPassword"
}, [
  /*#__PURE__*/_createTextVNode("新しいパスワード"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_14 = { class: "c-field__body" }
const _hoisted_15 = { class: "c-field__input" }
const _hoisted_16 = { class: "c-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newPasswordRetype"
}, [
  /*#__PURE__*/_createTextVNode("新しいパスワード(確認)"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_18 = { class: "c-field__body" }
const _hoisted_19 = { class: "c-field__input" }
const _hoisted_20 = { class: "c-field has-submit has-mt" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "更新する", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_Form, {
        onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.changePassword, this))),
        "validation-schema": _ctx.schema
      }, {
        default: _withCtx(({ errors, meta }) => [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.errorMsgRef), 1)
            ], 512), [
              [_vShow, _ctx.errorMsgRef]
            ]),
            _createElementVNode("fieldset", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Field, {
                      type: _ctx.oldPasswordToggle.fieldType,
                      id: "oldPassword",
                      name: "oldPassword",
                      modelValue: _ctx.oldPasswordRef,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldPasswordRef) = $event)),
                      maxlength: _ctx.PASSWORD_MAX_LENGTH,
                      autocomplete: "current-password",
                      required: ""
                    }, null, 8, ["type", "modelValue", "maxlength"]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.oldPasswordToggle.isOn }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.oldPasswordToggle)))
                    }, null, 2)
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.oldPassword), 513), [
                [_vShow, errors.oldPassword]
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Field, {
                      type: _ctx.newPasswordToggle.fieldType,
                      id: "newPassword",
                      name: "newPassword",
                      modelValue: _ctx.newPasswordRef,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPasswordRef) = $event)),
                      maxlength: _ctx.PASSWORD_MAX_LENGTH,
                      placeholder: "英字大小文字、数字を含む8文字以上",
                      autocomplete: "new-password",
                      required: ""
                    }, null, 8, ["type", "modelValue", "maxlength"]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.newPasswordToggle.isOn }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.newPasswordToggle)))
                    }, null, 2)
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newPassword), 513), [
                [_vShow, errors.newPassword]
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: _ctx.newPasswordRetypeToggle.fieldType,
                      id: "newPasswordRetype",
                      name: "newPasswordRetype",
                      value: "",
                      maxlength: _ctx.PASSWORD_MAX_LENGTH,
                      placeholder: "英字大小文字、数字を含む8文字以上",
                      autocomplete: "new-password",
                      required: ""
                    }, null, 8, ["type", "maxlength"]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.newPasswordRetypeToggle.isOn }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.newPasswordRetypeToggle)))
                    }, null, 2)
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newPasswordRetype), 513), [
                [_vShow, errors.newPasswordRetype]
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "c-btn is-submit",
                  disabled: !meta.valid || _ctx.isDeterringRef
                }, _hoisted_23, 8, _hoisted_21),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["c-btn c-btn--outline", { 'is-disabled':_ctx.isDeterringRef }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.push({ name: 'MypageTop' })))
                }, _hoisted_25, 2)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ], 64))
}